import React from 'react';
import { Helmet } from 'react-helmet';
import Header from './components/Header';

function AboutUs() {
  const state = {
    activeTab: {
      home: '',
      aboutUs: 'active',
      staff: '',
      apply: '',
    },
    linkWebsite: '/aboutus',
  };

  return (
    <>
      <Helmet>
        <title>Sobre Nós - Alliance Virtual</title>
      </Helmet>
      <Header activeTab={state.activeTab} linkWebsite={state.linkWebsite} />
    </>
  );
}

export default AboutUs;
